import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Conditional className composition with Tailwind-aware deduplication.
 * Later classes win on conflict: `cn('px-2', 'px-4')` → `'px-4'`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
